import className from 'classnames/bind';
import classNames from 'classnames';
import PropTypes from "prop-types";
import React from "react";
import {LazyMotion, m} from "framer-motion";
import Link from "next/link";
import { twMerge } from 'tailwind-merge'

import styles from './SocialLinks.module.scss';
// import ImgFacebook from '@/lib/assets/images/soc-fb-w.svg';
// import ImgFacebook from '@/lib/assets/images/soc-fb-w.svg';
import ImgFacebookRounded from '@/lib/assets/images/share_facebook.svg';
// import ImgTwitter from '@/lib/assets/images/soc-tw-w.svg';
import ImgTwitterRounded from '@/lib/assets/images/share_twitter.svg';
// import ImgInstagram from '@/lib/assets/images/soc-ig-w.svg';
import ImgInstagramRounded from '@/lib/assets/images/share_instagram.svg';
// import ImgYoutube from '@/lib/assets/images/soc-yt-w.svg';
// import ImgTiktok from '@/lib/assets/images/tiktok-w.svg';
// import ImgGoogleNews from '@/lib/assets/images/google-news-white.svg';
// import ImgLinkedin from '@/lib/assets/images/linkedin-w.svg';
import ImgLinkedinRounded from '@/lib/assets/images/share_linkedin.svg';
// import ImgReddit from '@/lib/assets/images/reddit-w.svg';
// import ImgPinterest from '@/lib/assets/images/share_pinterest-white.svg';
import ImgMastodonRounded from '@/lib/assets/images/share_mastodon.svg';
import ImgWebRounded from '@/lib/assets/images/share_web.svg';
import ImgEmailRounded from '@/lib/assets/images/share_email.svg';

const cx = className.bind(styles);
const list = {
  facebookUrl: ImgFacebookRounded,
  twitterUrl: ImgTwitterRounded,
  instagramUrl: ImgInstagramRounded,
  linkedinUrl: ImgLinkedinRounded,
  mastodonUrl: ImgMastodonRounded,
  webUrl: ImgWebRounded,
  mailTo: ImgEmailRounded,
};

const variants = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: {stiffness: 1000, velocity: -100}
    }
  },
  closed: {
    y: 5,
    opacity: 0,
    transition: {
      y: {stiffness: 1000}
    }
  }
};

export default function SocialLinks(
  {
    className,
    size = 'small',
    align = 'left',
    ...props
  }
) {
  return (
    <LazyMotion features={() => import("framer-motion").then((mod) => mod.domAnimation)}>
      <div className={cx([
        'clear-both',
        {[`size--${size}`]: Boolean(size)},
        `align--${align}`,
        className
      ])}>
        <ul className={twMerge(classNames(
          'flex flex-wrap justify-start w-full',
          {'justify-center': 'center' === align},
          {'max-md:justify-center': 'centerToLeft' === align},
        ))}>
          {Object.keys(list).map((key) => {
            if (!props?.[key]) {
              return null;
            }

            const url = props[key]?.includes('http') ? props[key] : ((value) => {
              switch (key) {
                case 'twitterUrl':
                  return `https://twitter.com/${value}`;
                case 'mailTo':
                  return `mailto:${value}`;
                default:
                  return value;
              }
            })(props[key]);

            if (!url) {
              return null;
            }

            return (
              <m.li key={`${key}`} variants={variants} className={classNames('m-1')}>
                <Link
                  aria-label={`${key}`}
                  href={url ?? ''}
                  target="_blank"
                  className={twMerge(classNames(
                    'group inline-block p-2 !transition-all',
                    '!text-navy dark:!text-silver',
                    'hover:!text-navy-500 dark:hover:!text-silver-100',
                    'hover:!fill-navy-500 dark:hover:!fill-silver-100',
                    'hover:[&_path]:!fill-navy-500 dark:hover:[&_path]:!fill-silver-100',
                    {'[&_svg_path]:!fill-white dark:[&_svg_path]:!fill-black hover:[&_svg_path]:!fill-white hover:dark:[&_svg_path]:!fill-black': 'linkedinUrl' === key},
                  ))}
                  rel="noopener noreferrer"
                  prefetch={false}
                >
                  {React.createElement(list?.[key], {
                    className: classNames(
                      'w-[30px] h-[30px] object-contain',
                      {'[&_path]:!text-white dark:[&_path]:!text-black': key === 'linkedinUrl'}
                    )
                  })}
                </Link>
              </m.li>
            );
          })}
        </ul>
      </div>
    </LazyMotion>

  );
}

SocialLinks.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'large']),
  align: PropTypes.oneOf(['left', 'center', 'centerToLeft']),

  facebookUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  instagramUrl: PropTypes.string,
  youtubeUrl: PropTypes.string,
  tiktokUrl: PropTypes.string,
  googleNews: PropTypes.string,
  linkedinUrl: PropTypes.string,
  redditUrl: PropTypes.string,
  pinterestUrl: PropTypes.string,
  mastodonUrl: PropTypes.string,
  webUrl: PropTypes.string,
  mailTo: PropTypes.string,
};
